<template lang="pug">

    tr
        // Auflage
        td {{ value.printing }}
        td
            number-field.ui.small.input.field(v-model='production' v-bind:disabled="disabled" v-bind:step="0.01")
        td
            number-field.ui.small.input.field(v-model='pricePerItem' v-bind:disabled="disabled" v-bind:step="0.0001")
        td
            number-field.ui.small.input.field(v-model='shipping' v-bind:disabled="disabled" v-bind:step="0.01")
        td {{ sum }}
        td
            text-field.ui.small.input.field(v-model='noteBySupplier' v-bind:disabled="disabled")

</template>

<script>
    import * as R from 'ramda'
    import round from 'lodash/round'
    import NumberField from '@/components/form/NumberField'
    import TextField from '@/components/form/TextField'

    //noinspection ReservedWordAsName,JSUnusedGlobalSymbols
    export default {

        components: { NumberField, TextField },

        computed: {
            noteBySupplier: {
                get() { return this.value.noteBySupplier },
                set(value) { this.updateValue('noteBySupplier', value) }
            },
            pricePerItem: {
                get() { return round(this.production / this.value.printing, 4) },
                set(value) { this.production = value * this.value.printing }
            },
            production: {
                get() { return this.value.production },
                set(value) { this.updateValue('production', round(value, 2)) }
            },
            shipping: {
                get() { return this.value.shipping },
                set(value) { this.updateValue('shipping', value) }
            },
            sum() {
                const production   = this.production || 0
                const shipping     = this.shipping || 0
                const sum          = round(production + shipping, 2)

                if (sum > 0) {
                    return `${sum} €`
                } else {
                    return '-'
                }
            }
        },

        methods: {

            updateValue(property, value) {
                this.$emit('input', R.assoc(property, value, this.value))
            }

        },

        props: {

            disabled: {
                type: Boolean,
                default: false
            },

            value: {
                type: Object,
                required: true
            }

        }

    }

</script>
